import { render, staticRenderFns } from "./IsBlocked.vue?vue&type=template&id=3951e8ac&"
import script from "./IsBlocked.vue?vue&type=script&lang=js&"
export * from "./IsBlocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports